module.exports = [{"title":"Date","eventOnly":true},{"title":"Course Title"},{"title":"Location","eventOnly":true},{"title":"Subject Area"},{"title":"Credits"},{"title":"Price"},{"title":"Action"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/components/marketplaceTable/tableHeaders.json
// module id = 1322
// module chunks = 0